var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWinterBreakAsideMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 178,
    viewBox: "0 0 328 178",
    fill: "none",
    id: "svg29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 104.38,7.10668 c 0.017,-0.14224 0.223,-0.14224 0.24,0 l 0.142,1.19324 c 0.182,1.54079 1.397,2.75558 2.938,2.93838 l 1.193,0.1416 c 0.143,0.0169 0.143,0.2233 0,0.2402 l -1.193,0.1416 c -1.541,0.1828 -2.756,1.3976 -2.938,2.9384 l -0.142,1.1932 c -0.017,0.1423 -0.223,0.1423 -0.24,0 l -0.142,-1.1932 c -0.182,-1.5408 -1.397,-2.7556 -2.938,-2.9384 l -1.193,-0.1416 c -0.1426,-0.0169 -0.1426,-0.2233 0,-0.2402 l 1.193,-0.1416 c 1.541,-0.1828 2.756,-1.39759 2.938,-2.93838 z",
    stroke: "#f3f4f9",
    strokeWidth: 3,
    strokeLinejoin: "bevel",
    id: "path12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 272.934,158.754 c 0.068,-0.126 -0.1,-0.245 -0.196,-0.139 l -0.804,0.893 c -1.039,1.152 -2.732,1.443 -4.096,0.703 l -1.056,-0.573 c -0.126,-0.068 -0.245,0.101 -0.139,0.197 l 0.893,0.804 c 1.153,1.038 1.444,2.732 0.704,4.095 l -0.573,1.056 c -0.069,0.126 0.1,0.246 0.196,0.139 l 0.804,-0.893 c 1.039,-1.152 2.732,-1.443 4.096,-0.703 l 1.056,0.573 c 0.126,0.068 0.245,-0.101 0.139,-0.196 l -0.893,-0.805 c -1.153,-1.038 -1.444,-2.731 -0.704,-4.095 z",
    stroke: "#f3f4f9",
    strokeWidth: 3,
    strokeLinejoin: "bevel",
    id: "path14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 322.197,182.399 3.408,-15.94 -3.414,15.938 m -0.007,0.001 -9.065,-14.004 9.06,14.008 m -0.004,0.005 -16.228,-3.865 16.227,3.871 m 0.001,0.006 -13.885,8.539 13.889,-8.533 m 0.005,0.004 -3.408,15.94 3.414,-15.939 m 0.007,-0.001 9.065,14.004 -9.06,-14.007 m 0.004,-0.005 16.228,3.864 -16.227,-3.871 m -10e-4,-0.006 13.885,-8.538 -13.889,8.532",
    stroke: "#f3f4f9",
    strokeWidth: 5,
    id: "path16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 25.5033,0.984032 31.9204,-14 25.5093,0.986519 M 25.5139,0.990972 41,-5.21323 25.5165,0.996862 m 0,0.006288 L 41,7.21324 25.5139,1.00904 M 25.5093,1.01349 31.9204,16 25.5033,1.01598 m -0.0065,0 L 19.0797,16 25.4907,1.01349 M 25.4861,1.00904 10,7.21324 25.4835,1.00315 m 0,-0.006288 L 10,-5.21323 25.4861,0.990972 M 25.4907,0.986519 19.0797,-14 25.4968,0.984032",
    stroke: "#f3f4f9",
    strokeWidth: 5,
    id: "path18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M -5.49675,111.984 0.920352,97 -5.49066,111.987 m 0.0046,0.004 L 10,105.787 l -15.48349,6.21 m 0,0.006 L 10,118.213 -5.48606,112.009 m -0.0046,0.004 L 0.920352,127 -5.49675,112.016 m -0.00649,0 -6.41706,14.984 6.41097,-14.987 m -0.0046,-0.004 -15.48607,6.204 15.4835,-6.21 m 0,-0.006 -15.4835,-6.21 15.48607,6.204 m 0.0046,-0.004 L -11.9203,97 l 6.41706,14.984",
    stroke: "#f3f4f9",
    strokeWidth: 5,
    id: "path20"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs27"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38020_40450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 178,
    rx: 8,
    fill: "white",
    id: "rect24"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterBreakAsideMobile);
export default __webpack_public_path__ + "static/media/winterBreakAside_mobile.4d884d7a8e9681eec40f70a2886591b2.svg";
export { ForwardRef as ReactComponent };